import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=0c58e111&"
import script from "./PopUp.vue?vue&type=script&lang=js&"
export * from "./PopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c58e111', component.options)
    } else {
      api.reload('0c58e111', component.options)
    }
    module.hot.accept("./PopUp.vue?vue&type=template&id=0c58e111&", function () {
      api.rerender('0c58e111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/PopUp.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/PopUp.vue
// module id = oXH5
// module chunks = 0